import React from "react";
import "./AboutUs.css";

export default function AboutUs() {
  return (
    <div className="aboutus1-container">
      <h1 className="aboutus1-title">About Us</h1>
      <div className="aboutus1-content">
        <p className="aboutus1-text">
          With over 52 years of excellence in the diamond industry,{" "}
          <strong>Pansuriya Impex</strong> stands as a trusted name in the
          sourcing, manufacturing, and global distribution of rough and polished
          diamonds.
        </p>
        <p className="aboutus1-text">
          Founded in 1972 in Surat—India’s diamond capital—we began our journey
          at the heart of the industry. By 2000, we expanded our reach with the
          establishment of our Mumbai sales office, setting the foundation for
          our presence in the international market.
        </p>
        <p className="aboutus1-text">
          Today, we serve a global clientele of retailers, designers, and
          manufacturers, offering a wide range of commercial-grade diamonds in
          various sizes, colors, and shapes. At Pansuriya Impex, we blend
          heritage with innovation to meet the evolving demands of a
          style-conscious world.
        </p>

        <h2 className="aboutus1-subheading">What We Do</h2>
        <p className="aboutus1-text">
          From sourcing to cutting, polishing, and exporting, we oversee every
          stage of the diamond lifecycle. Our team of seasoned experts ensures
          each stone meets the highest standards of quality, consistency, and
          ethical sourcing.
        </p>

        <h2 className="aboutus1-subheading">Our Mission</h2>
        <p className="aboutus1-text">
          To expand the global network through which Pansuriya Impex diamonds
          are accessed, making fine quality diamonds available to customers—no
          matter where they are in the world.
        </p>

        <h2 className="aboutus1-subheading">Our Values</h2>
        <ul className="aboutus1-list">
          <li className="aboutus1-list-item">
            <strong>Quality:</strong> Each diamond is meticulously selected,
            crafted, and inspected to ensure premium excellence.
          </li>
          <li className="aboutus1-list-item">
            <strong>Integrity:</strong> Ethical business practices and full
            transparency guide everything we do.
          </li>
          <li className="aboutus1-list-item">
            <strong>Service:</strong> We provide personalized service tailored
            to the unique needs of every client.
          </li>
          <li className="aboutus1-list-item">
            <strong>Innovation:</strong> Our continuous investment in technology
            and process improvement keeps us ahead in a fast-evolving industry.
          </li>
          <li className="aboutus1-list-item">
            <strong>People:</strong> We value and support our employees—our most
            important asset—by fostering growth, well-being, and a culture of
            excellence.
          </li>
        </ul>
      </div>
    </div>
  );
}
